import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/ui/tabs';
import { FileText, Lightbulb, Archive, Calendar as CalendarIcon, History } from 'lucide-react';
import { PlannerPanel } from '../components/content/PlannerPanel';
import { InspirationPanel } from '../components/content/InspirationPanel';
import { BankPanel } from '../components/content/BankPanel';
import { ArchivePanel } from '../components/content/ArchivePanel';

export const ContentTab = () => {
  return (
    <div className="p-4 space-y-4 max-w-2xl mx-auto" data-testid="content-tab">
      <div className="text-center py-4">
        <div className="inline-flex items-center justify-center w-12 h-12 bg-sky-100 dark:bg-sky-900/30 rounded-2xl mb-3">
          <FileText className="w-6 h-6 text-sky-600 dark:text-sky-400" />
        </div>
        <h1 className="text-2xl font-outfit font-bold text-sky-600 dark:text-sky-400">Content</h1>
        <p className="text-sm text-muted-foreground mt-2 max-w-sm mx-auto">
          Plan, organize, and prepare your social media content — one sit-down a week.
        </p>
      </div>

      <Tabs defaultValue="planner" className="w-full">
        <TabsList className="grid grid-cols-4 w-full">
          <TabsTrigger value="planner" data-testid="content-subtab-planner">
            <CalendarIcon className="w-3.5 h-3.5 mr-1" />
            <span className="hidden sm:inline">Planner</span>
          </TabsTrigger>
          <TabsTrigger value="inspiration" data-testid="content-subtab-inspiration">
            <Lightbulb className="w-3.5 h-3.5 mr-1" />
            <span className="hidden sm:inline">Ideas</span>
          </TabsTrigger>
          <TabsTrigger value="bank" data-testid="content-subtab-bank">
            <Archive className="w-3.5 h-3.5 mr-1" />
            <span className="hidden sm:inline">Bank</span>
          </TabsTrigger>
          <TabsTrigger value="archive" data-testid="content-subtab-archive">
            <History className="w-3.5 h-3.5 mr-1" />
            <span className="hidden sm:inline">Archive</span>
          </TabsTrigger>
        </TabsList>
        <TabsContent value="planner" className="mt-4">
          <PlannerPanel />
        </TabsContent>
        <TabsContent value="inspiration" className="mt-4"><InspirationPanel /></TabsContent>
        <TabsContent value="bank" className="mt-4"><BankPanel /></TabsContent>
        <TabsContent value="archive" className="mt-4"><ArchivePanel /></TabsContent>
      </Tabs>
    </div>
  );
};

export default ContentTab;
